import { baseImport, basePost } from "./base";

// 客服中心渲染
export const getCenterConfigApi = (data?: any, options?: { silent?: boolean, skipAuthLogin?: boolean }) => basePost('/center/website', data, options);
// 获取问题分类列表
export const getCateListApi = (data?: any) => basePost('/center/get-ask', data);
// 获取问题列表
export const getQuestionListApi = (data?: any) => basePost('/center/get-problem', data);
// 获取问题详情
export const getQuestionDetailApi = (data?: any) => basePost('/center/problem-read', data);
// 点击问题有无用
export const setQuestionStatApi = (data?: any) => basePost('/center/problem-stat', data);

// 获取工单模板
export const getOrderTemplateApi = (data?: any) => basePost('/center/get-work-template', data);
// 创建工单
export const addOrderApi = (data?: any) => basePost('/work-order/add', data);
// 个人工单列表
export const getOrderListApi = (data?: any) => basePost('/work-order/list-order', data);
// 工单评价
export const evalOrderApi = (data?: any) => basePost('/work-order/evaluate', data);
// 查询创角的游戏
export const getRoleGameListApi = (data?: any) => basePost('/user/get-role-game', data);
// 上传图片
export const uploadImage = (data?: any) => baseImport('/center/upload-image', data);
